import React from 'react';

const HectorIcon = ({...rest}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <circle cx="12" cy="12" r="12" fill="white" />
      <path
        d="M14.4571 11.0487C14.6876 11.182 14.8557 11.4013 14.9246 11.6584C14.9936 11.9155 14.9577 12.1895 14.8249 12.4202L11.7646 17.8226C11.6314 18.0531 11.4121 18.2213 11.1549 18.2902C10.8978 18.3592 10.6238 18.3233 10.3931 18.1904C10.1626 18.0571 9.99438 17.8379 9.92536 17.5807C9.85634 17.3236 9.89215 17.0496 10.0249 16.8188L13.0838 11.4165C13.1498 11.3021 13.2377 11.2019 13.3424 11.1216C13.4472 11.0412 13.5667 10.9822 13.6943 10.9481C13.8218 10.9139 13.9548 10.9052 14.0857 10.9225C14.2166 10.9398 14.3428 10.9826 14.4571 11.0487Z"
        fill="url(#paint0_linear_7896_42319)"
      />
      <path
        d="M9.13843 11.585C9.13843 11.453 9.16443 11.3223 9.21494 11.2004C9.26546 11.0784 9.3395 10.9676 9.43284 10.8742C9.52618 10.7809 9.63699 10.7069 9.75895 10.6563C9.8809 10.6058 10.0116 10.5798 10.1436 10.5798H16.8251C17.0008 10.5798 17.1734 10.6259 17.3257 10.7134C17.478 10.8009 17.6047 10.9269 17.6932 11.0786C17.7822 11.2314 17.8294 11.4049 17.83 11.5817C17.8306 11.7585 17.7846 11.9323 17.6965 12.0856C17.6085 12.2389 17.4816 12.3663 17.3286 12.4549C17.1756 12.5435 17.0019 12.5902 16.8251 12.5902H10.1436C10.0116 12.5902 9.8809 12.5642 9.75895 12.5137C9.63699 12.4632 9.52618 12.3891 9.43284 12.2958C9.3395 12.2025 9.26546 12.0916 9.21494 11.9697C9.16443 11.8477 9.13843 11.717 9.13843 11.585Z"
        fill="url(#paint1_linear_7896_42319)"
      />
      <path
        d="M12.2298 6C12.408 5.99979 12.5831 6.04672 12.7374 6.13604C12.8916 6.22535 13.0195 6.35388 13.1081 6.50858C13.1966 6.66327 13.2427 6.83864 13.2416 7.01688C13.2405 7.19512 13.1922 7.3699 13.1018 7.52348L8.88792 14.3912C8.7987 14.5437 8.67109 14.67 8.5178 14.7578C8.36451 14.8455 8.19091 14.8916 8.01429 14.8913C7.83767 14.8911 7.6642 14.8445 7.51117 14.7563C7.35814 14.6681 7.23089 14.5414 7.14211 14.3887L7.13886 14.3833C7.04793 14.2283 7 14.0518 7 13.872C7 13.6923 7.04793 13.5158 7.13886 13.3608L11.3578 6.49844C11.447 6.34656 11.5745 6.22065 11.7275 6.13322C11.8804 6.04579 12.0536 5.99986 12.2298 6Z"
        fill="url(#paint2_linear_7896_42319)"
      />
      <path
        d="M16.8122 6.00323C16.9878 6.00428 17.16 6.0512 17.3118 6.13934C17.4636 6.22748 17.5898 6.35378 17.6777 6.50571C17.7657 6.65765 17.8124 6.82993 17.8132 7.00548C17.814 7.18103 17.7689 7.35375 17.6824 7.5065L16.5274 9.55188C16.4378 9.71065 16.3067 9.84207 16.1481 9.93209C15.9896 10.0221 15.8095 10.0673 15.6273 10.063H15.5912C15.4158 10.0592 15.2443 10.0097 15.0939 9.91936C14.9435 9.82898 14.8194 9.70085 14.7338 9.54769C14.6482 9.39452 14.6041 9.22164 14.6059 9.04618C14.6077 8.87072 14.6553 8.69879 14.7441 8.54742L15.9351 6.50276C16.0245 6.34968 16.1526 6.22288 16.3066 6.13517C16.4606 6.04747 16.635 6.00195 16.8122 6.00323Z"
        fill="url(#paint3_linear_7896_42319)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7896_42319"
          x1="8.46788"
          y1="7.82162"
          x2="14.3849"
          y2="17.9875"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF0078" />
          <stop offset="0.06" stopColor="#E80089" />
          <stop offset="0.2" stopColor="#AD00B4" />
          <stop offset="0.35" stopColor="#6200EB" />
          <stop offset="0.66" stopColor="#05D1CE" />
          <stop offset="1" stopColor="#007DEB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7896_42319"
          x1="10.3742"
          y1="6.24003"
          x2="16.7468"
          y2="17.1888"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF0078" />
          <stop offset="0.06" stopColor="#E80089" />
          <stop offset="0.2" stopColor="#AD00B4" />
          <stop offset="0.35" stopColor="#6200EB" />
          <stop offset="0.66" stopColor="#05D1CE" />
          <stop offset="1" stopColor="#007DEB" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_7896_42319"
          x1="8.32379"
          y1="7.35457"
          x2="15.4352"
          y2="19.5727"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF0078" />
          <stop offset="0.06" stopColor="#E80089" />
          <stop offset="0.2" stopColor="#AD00B4" />
          <stop offset="0.35" stopColor="#6200EB" />
          <stop offset="0.66" stopColor="#05D1CE" />
          <stop offset="1" stopColor="#007DEB" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_7896_42319"
          x1="13.954"
          y1="4.15672"
          x2="20.3266"
          y2="15.1055"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF0078" />
          <stop offset="0.06" stopColor="#E80089" />
          <stop offset="0.2" stopColor="#AD00B4" />
          <stop offset="0.35" stopColor="#6200EB" />
          <stop offset="0.66" stopColor="#05D1CE" />
          <stop offset="1" stopColor="#007DEB" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default HectorIcon;
